import React from 'react';
import PropTypes from 'prop-types';

import Services from '../services';
import withCollegeService from '../withCollegeService';

export const ServicesComponent = withCollegeService(
  Services,
  'studentLife.services',
  {},
  {
    academicCareerCounseling: 'field_he_special_services_id_ref',
    accommodationsForStudentsWithADHD: 'field_he_special_services_id_ref',
    assistanceForHearingImpaired: 'field_he_special_services_id_ref',
    assistanceForMobilityImpaired: 'field_he_special_services_id_ref',
    assistanceForVisuallyImpaired: 'field_he_special_services_id_ref',
    bookOnTapeForRFBD: 'field_he_special_services_id_ref',
    calculatorsAllowedInExams: 'field_he_special_services_id_ref',
    computersAllowedInExams: 'field_he_special_services_id_ref',
    dayCareServices: 'field_he_special_services_id_ref',
    dictionaryAllowedInExams: 'field_he_special_services_id_ref',
    ESL: 'field_he_special_services_id_ref',
    healthServicesAvailable: 'field_he_special_services_id_ref',
    internshipsWithPay: 'field_he_special_services_id_ref',
    internshipsWithoutPay: 'field_he_special_services_id_ref',
    jobPlacement: 'field_he_special_services_id_ref',
    LDSpecialists: 'field_he_special_services_id_ref',
    learningCenter: 'field_he_special_services_id_ref',
    libraryFacilities: 'field_he_special_services_id_ref',
    peerTutors: 'field_he_special_services_id_ref',
    professionalTutors: 'field_he_special_services_id_ref',
    readingMachine: 'field_he_special_services_id_ref',
    remedialServices: 'field_he_special_services_id_ref',
    spellcheckerAllowedInExam: 'field_he_special_services_id_ref',
    studentEmployment: 'field_he_special_services_id_ref',
    tapeRecordingInClass: 'field_he_special_services_id_ref',
    tapingOfBooksNotFromRFBD: 'field_he_special_services_id_ref',
    veteran: 'field_he_special_services_id_ref',
    aspergersAutismSupportServices: 'field_he_special_services_id_ref',
    ROTCArmy: 'field_he_rotcarmy',
    ROTCNavy: 'field_he_rotcnavy',
    ROTCAirforce: 'field_he_rotcair',
    ROTCServicepersonOpportunityCollege: 'field_he_rotcservperoppcollege',
  },
);

const ServicesCmp = ({ onChange, initialValue }) =>
  (
    <React.Fragment>
      <ServicesComponent />
    </React.Fragment>
  );

ServicesCmp.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default ServicesCmp;
